import { useModalStore } from '@/entities/Modal';
import { ModalWrapper } from '@/shared/ui/ModalWrapper';
import { DepositForm } from '@/features/LK/DepositForm';

export const DepositModal = () => {
    const { isDepositModalOpen, setIsDepositModalOpen } = useModalStore();

    return (
        <ModalWrapper id="depositModal" isOpened={isDepositModalOpen} setIsOpened={setIsDepositModalOpen}>
            <DepositForm />
        </ModalWrapper>
    );
};
